import { useState, useEffect } from 'react';
import { collection, getDocs, setDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import RsvpMember from './RsvpMember';

function Rsvp() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    async function fetchFamilyMembers() {
      const user = auth.currentUser;
      if (!user) return;

      const tokenResult = await user.getIdTokenResult();
      const familyGroup = tokenResult.claims.familyGroup;
      if (!familyGroup) return;

      const guestsSnapshot = await getDocs(collection(db, 'rsvp', familyGroup, 'guests'));
      setMembers(guestsSnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          ref: doc.ref,
          id: doc.id,
          attending: data.attending ?? null,
          travel: data.travel ?? null,
          dietary: data.dietary ?? [],
          dietaryOther: data.dietaryOther ?? '',
          firstName: data.firstNames?.[0],
          lastName: data.lastNames?.[0],
          isNightDo: data.isNightDo ?? false,
        };
      }));
    }
    fetchFamilyMembers();
  }, []);

  async function updateMember(index, updates) {
    const ref = members[index].ref;
    setMembers(prev => prev.map((m, i) => i === index ? { ...m, ...updates } : m));
    if (ref) {
      await setDoc(ref, updates, { merge: true });
    }
  }

  return (
    <div className="container">
      <h1 className="tangerine-bold">RSVP</h1>

      <form>
        {members.map((member, index) => (
          <RsvpMember
            key={member.id ?? index}
            member={member}
            index={index}
            showName={members.length > 1}
            onUpdate={(updates) => updateMember(index, updates)}
          />
        ))}
      </form>
    </div>
  )
}

export default Rsvp;
